module.exports = __webpack_public_path__ + "static/gymondo_social_de-450f734e9bbaf626b6b4f328868dc0b6.jpg";